<template>
  <PageContainer title="Instrutores">
    <div slot="header">
      <Button @handle:click="atualizarInstrutores" text="Atualizar instrutores" color="secondary">
        <Cached :size="18" />
      </Button>
    </div>

    <div class="loading" v-if="!loaded">
      <LoadingSpinner />
    </div>

    <Box v-else space="medium" class="veiculos-container">
      <Form @submit.prevent="handleSubmit" class="main-form">
        <div class="inputs">
          <div class="inputs-row">
            <Select class="input-full" :options="schemaOptions" legend="Autoescola"
              placeholder="Selecione uma autoescola" :modelValue="schema" @update:modelValue="$event => schema = $event"
              :disabled="loading" />

            <Input class="input-full" legend="Nome" placeholder="Digite o nome do instrutor" :modelValue="nome"
              @update:modelValue="$event => nome = $event" :disabled="loading" />

            <Input mask="###.###.###-##" legend="CPF" placeholder="000.000.000-00" :modelValue="cpf"
              @update:modelValue="$event => cpf = $event" class="input-full input-cpf" />
          </div>
        </div>

        <div class="buttons">
          <Button type="button" @handle:click="clearInputs" text="Limpar" :fill="false" color="danger"
            :disabled="loading">
            <CloseCircleOutline :size="18" />
          </Button>

          <Button type="submit" text="Consultar" color="primary" :disabled="loading">
            <Magnify :size="18" />
          </Button>
        </div>
      </Form>

      <div class="loading" v-if="loading">
        <LoadingSpinner />
      </div>

      <div class="table-container" v-else-if="instrutores.length > 0">
        <div class="table-header">
          <StatusLegend :statusOptions="statusLegendOptions" />

          <Paginate :total-pages="paginationData.lastPage" :current-page="paginationData.currentPage"
            @page-changed="fetchInstrutores" />
        </div>

        <Table :headers="['#', 'Nome', 'CPF', 'Ações']">
          <tr v-for="instrutor in instrutores" :key="instrutor.id_instrutor">
            <td>
              <BadgeCircle color="red" v-if="!instrutor.flg_ativo" />
              <BadgeCircle color="green" v-else />
            </td>
            <td>{{ instrutor.nome }}</td>
            <td>{{ utils.formatarCPF(instrutor.cpf) }}</td>
            <td>
              <div class="actions">
                <div v-if="instrutor.flg_ativo">
                  <IconButton @handle:click="logout(instrutor)" color="danger" title="Deslogar instrutor"
                    :disabled="loadingActions">
                    <Logout :size="19" />
                  </IconButton>
                </div>
                <IconButton @handle:click="perfil(instrutor)" color="primary" title="Perfil"
                  :disabled="loadingActions">
                  <AccountEditOutline :size="19" />
                </IconButton>
              </div>
            </td>
          </tr>
        </Table>
      </div>
      <Modal ref="perfil" title="Informações do instrutor">
        <Perfil :instrutorSelecionado="instrutorSelecionado" :schema="schemaSelecionado"></Perfil>
      </Modal>
    </Box>
  </PageContainer>
</template>

<script>
import utils from '../../../services/utils' 
import PageContainer from 'core/PageContainer'
import Box from 'core/Box'
import Button from 'core/Button'
import LoadingSpinner from 'core/LoadingSpinner'
import Select from 'core/Select'
import Input from 'core/Input'
import StatusLegend from 'core/StatusLegend'
import Paginate from 'core/Paginate'
import Table from 'core/Table'
import BadgeCircle from 'core/BadgeCircle'
import IconButton from 'core/IconButton'
import Cached from 'icons/Cached'
import Magnify from 'icons/Magnify'
import CloseCircleOutline from 'icons/CloseCircleOutline'
import Logout from 'icons/Logout'
import Modal from 'core/Modal'
import Perfil from './modal/Perfil.vue'
import AccountEditOutline from 'icons/AccountEditOutline'

import urlApiV2 from '@/router/urlApiV2'

export default {
  name: 'ListarInstrutores',
  components: {
    PageContainer,
    Box,
    Button,
    LoadingSpinner,
    Select,
    Input,
    StatusLegend,
    Paginate,
    Table,
    BadgeCircle,
    IconButton,
    Modal,
    Perfil,

    Cached,
    Magnify,
    CloseCircleOutline,
    Logout,
    AccountEditOutline
  },

  data() {
    return {
      idRole: localStorage.getItem('id_role'),
      utils,
      schema: '',
      nome: '',
      cpf: '',
      paginationData: {
        currentPage: 1,
        lastPage: 1,
        total: 0,
      },
      schemaOptions: [],
      instrutores: [],
      loaded: false,
      loading: false,
      loadingActions: false,
      instrutorSelecionado: null,
      schemaSelecionado: null,
    }
  },
  computed: {
    statusLegendOptions() {
      const ativos = this.instrutores.filter(v => v.flg_ativo === true).length
      const inativos = this.instrutores.filter(v => v.flg_ativo === false).length

      return [
        { legend: `Ativos - ${ativos}`, color: 'green' },
        { legend: `Inativos - ${inativos}`, color: 'red' },
      ]
    }
  },
  async created() {
    await this.fetchCfcs()

    this.loaded = true
  },
  methods: {
    async fetchCfcs() {
      await this.$http.get(`${process.env.VUE_APP_URL_API_V2}/autoescola`)
        .then((res) => {
          this.schemaOptions = res.body.dados.map(cfc => ({ value: cfc.tenant_schema, text: cfc.nome_fantasia }))
        })
        .catch((error) => {
          this.$toasted.show('Erro:' + error.body.mensagem, {
            position: 'top-right',
          })
        })
    },
    async fetchInstrutores(page = 1) {
      this.loading = true

      const params = {
        page: page,
        schema: this.schema,
        nome: this.nome,
        cpf: this.cpf,
      }
      this.schemaSelecionado = this.schema

      await this.$http.get(`${process.env.VUE_APP_URL_API_V2}/instrutor/consultar`, { params })
        .then((res) => {
          if (res.body.dados.data < 1) {
            this.$toasted.show('Nenhum resultado encontrado!', {
              position: 'top-right',
            })

            return
          }

          this.instrutores = res.body.dados.data

          this.paginationData = {
            currentPage: res.body.dados.current_page,
            lastPage: res.body.dados.last_page,
            total: res.body.dados.total,
          }
        })
        .catch((err) => {
          this.$toasted.show(err.body.mensagem, {
            position: 'top-right',
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    async handleSubmit() {
      if (this.validateInputs()) {
        await this.fetchInstrutores()
      }
    },
    validateInputs() {
      if (!this.schema) {
        this.launchToast('Por favor, selecione uma autoescola!')

        return false
      }

      return true
    },
    clearInputs() {
      this.schema = ''
      this.nome = ''
      this.cpf = ''
    },

    launchToast(mensagem) {
      this.$toasted.show(mensagem, {
        position: 'top-right',
      });
    },

    async atualizarInstrutores() {
      if (this.schema == '') {
        this.launchToast('Selecione uma autoescola!');
        return;
      }

      this.loading = true

      await this.$http.get(urlApiV2 + '/getran/atualizar/instrutores?schema=' + this.schema).then(function (response) {
        this.launchToast(response.data.mensagem)
        this.fetchInstrutores()
        this.loading = false
      }).catch(function (error) {
        this.launchToast(error.data.dados)
        this.loading = false
      })
    },

    async logout(instrutor) {
      this.loadingActions = true

      await this.$http.post(urlApiV2 + '/user/logout/' + instrutor.id_instrutor).then(response => {
        this.loadingActions = false

        this.launchToast(response.data.mensagem)
      }).catch(function (error) {
        this.loadingActions = false

        this.launchToast(error.data.mensagem)
      })
    },

    perfil(instrutor) {
      this.$refs.perfil.open()
      this.instrutorSelecionado = instrutor
    },
  },
}
</script>

<style lang="scss" scoped>
.loading {
  display: flex;
  justify-content: center;
  align-items: center;
}

.veiculos-container {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;

  .main-form {
    display: flex;
    flex-direction: column;
    gap: 2.5rem;

    .inputs {
      display: flex;
      flex-direction: column;
      gap: 1.5rem;

      .inputs-row {
        display: flex;
        flex-wrap: wrap;
        gap: 1.5rem;

        .input-full {
          flex: 1;
        }
      }
    }

    .buttons {
      align-self: flex-end;

      display: flex;
      gap: 0.5rem;
    }
  }

  .table-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    .table-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .actions {
      display: flex;
      align-items: center;

      div {
        padding: 0 0.5rem;
        display: flex;
        justify-content: center;

        &:not(:first-child) {
          border-left: 1px solid #ECECEC;
        }

        &:not(:last-child) {
          border-right: 1px solid #ECECEC;
        }
      }
    }
  }
}

</style>
